<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/coursetypes/edit/' + coursetype.id,
          props: { id: coursetype.id }
        }"
        v-if="$can('coursetype-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(coursetype.id)" v-if="$can('coursetype-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="coursetype.name"
                  v-model="coursetype.name"
                  :label="$t('coursetypes.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.category"
                  v-model="coursetype.category"
                  :label="$t('coursetypes.category')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.coursetype_id"
                  v-model="coursetype.coursetypegroup.fullname"
                  :label="$t('coursetypes.coursetype_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.code"
                  v-model="coursetype.code"
                  :label="$t('coursetypes.code')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.teaching_plan"
                  v-model="coursetype.teaching_plan"
                  :label="$t('coursetypes.teaching_plan')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.teaching_material"
                  v-model="coursetype.teaching_material"
                  :label="$t('coursetypes.teaching_material')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetype.status"
                  :value="this.$dd_course_types_status(coursetype.status)"
                  :label="$t('coursetypes.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      coursetype: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "coursetype/" + this.id)
      .then((res) => {
        this.coursetype = res.data.data
        this.page_title = this.$t("coursetypes.view_coursetype", {
          name: this.coursetype.name
        })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetype/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetypes")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
